import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card, Alert, AlertTitle, TextField, FormControlLabel, Switch } from "@mui/material";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import MDButton from "../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import * as yup from "yup";
import { postData } from "../../Utils/Http/api";

const OrganismoAdd = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ denominacion: '', cuit: '', fechaContratoDesde: '', fechaContratoHasta: '', domicilio: '', sistema: '', sistemaClave: '', mailInstitucional: '', mailInstitucionalClave: '', observaciones: '', activo: true });
  const [mensaje, setMensaje] = useState('');
  const [exito, setExito] = useState(false);
  const [grabando, setGrabando] = useState(false);

  const validationSchema = yup.object().shape({
    denominacion: yup.string().required('Denominación obligatoria'),
    cuit: yup.string().required('CUIT obligatorio'),
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleVolver = () => { navigate('/OrganismoList'); };

  const handleSubmit = async () => {
    try {
      await validationSchema.validate(formData);
      setGrabando(true);
      const payload = { denominacion: formData.denominacion, cuit: formData.cuit, fechaContratoDesde: formData.fechaContratoDesde || null, fechaContratoHasta: formData.fechaContratoHasta || null, domicilio: formData.domicilio, sistema: formData.sistema, sistemaClave: formData.sistemaClave, mailInstitucional: formData.mailInstitucional, mailInstitucionalClave: formData.mailInstitucionalClave, observaciones: formData.observaciones, activo: formData.activo ? 1 : 0 };
      const res = await postData('/OrganismoAlta', payload);
      if (res?.isSuccess) { setMensaje('Organismo agregado'); setExito(true); }
      else { setMensaje(res?.error || 'Error al guardar'); setExito(false); setGrabando(false); }
    } catch (error) { setMensaje(error.message || 'Error de validación'); setExito(false); setGrabando(false); }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card style={{ width: '100%' }}>
        <MDBox variant="gradient" bgColor="secondary" borderRadius="lg" coloredShadow="light" mx={2} mt={-3} p={3} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>Agregar Organismo</MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>Permite agregar un nuevo organismo.</MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}><MDInput type="text" name="denominacion" label="Denominación" value={formData.denominacion} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="cuit" label="CUIT" value={formData.cuit} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><TextField type="date" name="fechaContratoDesde" label="Fecha desde" value={formData.fechaContratoDesde} onChange={handleInputChange} fullWidth InputLabelProps={{ shrink: true }} /></MDBox>
            <MDBox mb={2}><TextField type="date" name="fechaContratoHasta" label="Fecha hasta" value={formData.fechaContratoHasta} onChange={handleInputChange} fullWidth InputLabelProps={{ shrink: true }} /></MDBox>
            <MDBox mb={2}><MDInput type="text" name="domicilio" label="Domicilio" value={formData.domicilio} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="sistema" label="Sistema" value={formData.sistema} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="sistemaClave" label="Sistema Clave" value={formData.sistemaClave} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="mailInstitucional" label="Mail Institucional" value={formData.mailInstitucional} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="mailInstitucionalClave" label="Mail Clave" value={formData.mailInstitucionalClave} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}><MDInput type="text" name="observaciones" label="Observaciones" value={formData.observaciones} onChange={handleInputChange} fullWidth/></MDBox>
            <MDBox mb={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.activo}
                    onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                    color="success"
                  />
                }
                label="Activo"
              />
            </MDBox>

            <MDBox mb={1} style={{ display: 'flex', gap: '16px' }}>
              <MDButton onClick={handleSubmit} variant="gradient" color="success" endIcon={<Save/>} disabled={grabando} fullWidth>Grabar</MDButton>
              <MDButton onClick={handleVolver} variant="gradient" color="error" endIcon={<ExitToApp/>} fullWidth>Volver</MDButton>
            </MDBox>
          </MDBox>
        
          {mensaje && (
            <Alert severity={exito ? 'success' : 'error'}><AlertTitle>{exito ? 'Felicitaciones' : 'Error'}</AlertTitle>{mensaje}</Alert>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default OrganismoAdd;
